
import { defineComponent, PropType } from 'vue'
import Icon from '@/shared/ui/Icon/Icon.vue'
import { SkillProgress } from '@/types'
import rules from '@/shared/constants/rules'

export default defineComponent({
	name: 'SkillBubble',
	components: { Icon },
	emits: ['update:bonus'],
	props: {
		skill: {
			type: Object as PropType<SkillProgress>,
			required: true
		},
		experienceGained: {
			type: Number,
			required: true
		},
		bonus: {
			type: Number,
			required: true
		},
		isExperienceDisplayed: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		gradient() {
			const p = (this.skill.experience / rules.LEVEL_CUPS[this.skill.level - 1]) * 100
			return `linear-gradient(to top, #181818 0%, #181818 ${p}%, transparent ${p}%)`
		},
		experience() {
			return this.skill.experience + ' / ' + rules.LEVEL_CUPS[this.skill.level - 1]
		}
	},
	methods: {
		setBonus(value: number) {
			this.$emit('update:bonus', value)
		},
		signed(number: number, isZero = false): string {
			return new Intl.NumberFormat('en-US', {
				signDisplay: isZero ? 'exceptZero' : 'always'
			}).format(number)
		}
	}
})
